import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setBreadcrumb } from '../actions/breadcrumb'

import { RETURNS } from '../assets/constant'

class SummarySize extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.onClick = this.onClick.bind(this)
  }

  onClick() {
    if (!this.props.shipback.charged) {
      this.props.setBreadcrumb(RETURNS)
    }
  }

  render() {
    if (this.props.size != undefined) {
      var label = "dimensions." + this.props.size + ".label"
      var image = sizes[this.props.size]
      return (
       <div className="parcel">
          <a href="#" onClick={this.onClick}>
            <h3>{I18n.t('layouts.summary.parcel.title')}</h3>
            <p className="value">{I18n.t(label)}</p>
            <p><img src={image} alt={label} /></p>
          </a>
          <hr className="separator" />
        </div>
      )
    } else {
      return (<div></div>)
    }
  }
}

const mapStateToProps = state => ({
  size: state.shipback.size,
  shipback: state.shipback
})

const mapDispatchToProps = dispatch => bindActionCreators({ setBreadcrumb }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SummarySize)


// WEBPACK FOOTER //
// ./app/javascript/components/components/SummarySize.jsx